import { z } from 'zod';
import { ChunkRefSchema } from './source-ref.js';
import { ItemTagsSchema, coerceItemTagsV3ToV4 } from './item-tags.js';
import { ConceptOmissionSchema } from './concept-omission.js';
// Session 19AE: full .describe() for LLM clarity. Glossary spans multiple
// topics naturally (terms recur across chapters), hence v3 had caseIds[] /
// topicIds[] arrays already — earlier than other item schemas.
//
// 19BH Day 2 Step 2.4: ItemTags base applied. v3 had:
//   - caseIds: array(string).nullish().transform(v => v ?? [])  — LLM-tolerant
//   - topicIds: array(string).nullish().transform(v => v ?? undefined)
// v4 takes these over with ItemTagsSchema's strict required-array form. The
// coerceItemTagsV3ToV4 preprocess fills caseIds/topicIds from missing/null
// inputs before validation, preserving the LLM-tolerant intent (null → []).
// conceptIds is new — populated by Step 2.6 prompt injection (Day 2).
export const GlossaryItemSchema = z.preprocess(coerceItemTagsV3ToV4, ItemTagsSchema.extend({
    id: z.string().regex(/^[a-z][a-z0-9_]*$/, 'glossary id must be snake_case')
        .describe('Unique snake_case slug derived from term (e.g. `master_theorem`, `dual_problem`). Used as cross-ref target from flashcards / lecture notes.'),
    term: z.string().min(2)
        .describe('The term itself, in its primary language. ≥2 chars. Per contentLanguage mode: en/zh_en_terms keep English original; zh translates; en_zh_gloss adds Chinese parenthetical on first definition mention.'),
    shortDef: z.string().min(20)
        .describe('One-line definition (20-120 chars). Shown in tooltips + sidebar previews. Should be self-contained — readable without longDef.'),
    longDef: z.string().min(80)
        .describe('Full markdown definition. ≥80 chars (NOT just "see shortDef"). Include: precise wording, 1-2 examples, common mis-uses, related terms. Lead with **bold** term restated. Use lists for multi-part definitions. Constraint Session 19AO.'),
    tags: z.array(z.string()).nullish().transform((v) => v ?? [])
        .describe('Free-form classification tags (e.g. ["macroeconomics", "policy"]). LLM-tolerant: null/missing both → [].'),
    sourceRef: ChunkRefSchema.nullish()
        .describe('19BG+2 Phase 5 (DEBT-AW-SOURCEREF): citation anchor for the term\'s primary source mention. Optional for back-compat.'),
    omittedConcepts: z.array(ConceptOmissionSchema).nullish()
        .describe('K18 soft escape · concepts the LLM declared materially insufficient for this stage.'),
}).passthrough());
export const GlossarySchema = z.array(GlossaryItemSchema);
//# sourceMappingURL=glossary.js.map